<template>
  <div v-if="!tijiaoSuccess">
    <div class="detail-node" v-if="interviewRecordDetailFromDingMessageObj && interviewRecordDetailFromDingMessageObj.id > 0">
    <!--    高度填充-->
    <div style="height: .2rem; background-color: #fff;"></div>
    <div class="white-wrap">
      <div class="info-item clear">
        <div class="field">创建人</div>
        <div class="value">{{interviewRecordDetailFromDingMessageObj.creatorName}}</div>
      </div>
      <div class="info-item clear">
        <div class="field">沟通日期</div>
        <div class="value">{{interviewRecordDetailFromDingMessageObj.date | timeFilter}}</div>
      </div>
      <div class="info-item clear">
        <div class="field">沟通类型</div>
        <div class="value">{{interviewRecordDetailFromDingMessageObj.typeTxt}}</div>
      </div>
      <div class="info-item clear">
        <div class="field">沟通对象</div>
        <div class="value">{{interviewRecordDetailFromDingMessageObj.targetUserName}}</div>
      </div>
      <div class="info-item last clear">
        <div class="field">沟通主要内容提炼</div>
      </div>
      <div class="p-item last">
        {{interviewRecordDetailFromDingMessageObj.descriptions}}
      </div>
    </div>
    <div class="white-wrap">
      <div class="block-title">
        督办事项
      </div>
      <!--<div>
      {{id}}
      </div>
      <div>
        {{interviewRecordDetailFromDingMessageObj.items[0].itemUsers[0].status}}
      </div>
      <div>
        {{interviewRecordDetailFromDingMessageObj.operateTime}}
      </div>-->
      <!--      事项开始 自己还没填写的情况-->
      <div class="thing" v-if="1*interviewRecordDetailFromDingMessageObj.items[0].itemUsers[0].status < 2">
        <div class="info-item last clear">
          <div class="field">事项内容</div>
        </div>
        <div class="p-item">
          {{interviewRecordDetailFromDingMessageObj.items[0].descriptions}}
        </div>
        <div class="info-item clear">
          <div class="field">截止时间</div>
          <div class="value">{{interviewRecordDetailFromDingMessageObj.items[0].deadLine | dateTimeFilter}}</div>
        </div>
        <div class="info-item last clear">
          <div class="field">处理结果</div>
        </div>
        <textarea class="text-area" v-model="writeResult"></textarea>
        <div class="sub-btn" @click="comfirmInterviewRecords">提交</div>
      </div>
      <!--      事项结束-->
      <!--      事项开始 自己已经填写的情况-->
      <div class="thing" v-if="1*interviewRecordDetailFromDingMessageObj.items[0].itemUsers[0].status == 2">
        <div class="info-item last clear">
          <div class="field">事项内容</div>
        </div>
        <div class="p-item">
          {{interviewRecordDetailFromDingMessageObj.items[0].descriptions}}
        </div>
        <div class="info-item clear">
          <div class="field">截止时间</div>
          <div class="value">{{interviewRecordDetailFromDingMessageObj.items[0].deadLine | dateTimeFilter}}</div>
        </div>
        <div class="info-item clear" v-if="1*interviewRecordDetailFromDingMessageObj.items[0].itemUsers[0].status >= 1">
          <div class="field">提交时间</div>
          <div class="value">{{interviewRecordDetailFromDingMessageObj.items[0].itemUsers[0].completedTime | dateTimeFilter}}</div>
        </div>
        <div class="info-item last clear">
          <div class="field">处理结果
<!--            <span style="color:rgb(81,153,255);" v-if="+interviewRecordDetailFromDingMessageObj.items[0].itemUsers[0].status == 1"> ( 待确认 )</span>-->
            <span style="color:rgb(81,153,255);" v-if="+interviewRecordDetailFromDingMessageObj.items[0].itemUsers[0].status == 2"> ( 已确认 )</span>
          </div>
        </div>
        <div class="p-item last">
          {{interviewRecordDetailFromDingMessageObj.items[0].itemUsers[0].notes}}
        </div>
      </div>
      <!--      事项结束-->
    </div>
    <!--    高度填充-->
    <div style="height: .5rem;"></div>
  </div>
    <div class="no-data" v-else>
      {{message}}
    </div>
  </div>
  <div class="success" v-else>
    <img src="../assets/success.png" alt="">
    <div class="tip">操作成功</div>
  </div>
</template>


<script>
  import { getInterviewRecordsDetailFromDingMessage, submitInterviewRecords} from '../api/global';
  import {Toast} from "mint-ui";
  import { Indicator } from 'mint-ui';

  function repairZero(num) {
    return num < 10 ? '0' + num : num
  }


export default {
  name: 'Result',
  filters: {
    timeFilter(time) {
      var date = new Date(time)
      return date.getFullYear() + '-' + repairZero(date.getMonth() + 1) + '-' + repairZero(date.getDate())
    },
    dateTimeFilter(time) {
      var date = new Date(time)
      return date.getFullYear() +
              '-' +
              repairZero(date.getMonth() + 1) +
              '-' +
              repairZero(date.getDate()) +
              ' ' +
              repairZero(date.getHours()) +
              ':' +
              repairZero(date.getMinutes()) +
              ':' +
              repairZero(date.getSeconds())
    }
  },
  data() {
    return {
      interviewRecordDetailFromDingMessageObj: {},
      writeResult: '',
      id: '',
      tijiaoLock: false,
      tijiaoSuccess: false,
      message: '',
    };
  },
  methods: {
    // 获取景点分类下的景点列表
    getInterviewRecordsDetailFromDingMessage(id){
      const that = this;
      Indicator.open()
      getInterviewRecordsDetailFromDingMessage(id)
              .then((response) => {
                if(response.id<=0){
                  that.message = '该条记录已撤销'
                  Indicator.close()
                  return
                }
                Indicator.close()
                that.interviewRecordDetailFromDingMessageObj = response
                that.writeResult = response.items[0].itemUsers[0].notes
              })
              .catch((error) => {
                Indicator.close()
                Toast(error);
              });
    },

    // 主责任人确认完成
    comfirmInterviewRecords(){
      const that = this;
      const id = that.id

      if(that.tijiaoLock){
        return
      }

      that.tijiaoLock = true

      if(that.writeResult == ''){
        Toast('请填写处理结果')
        that.tijiaoLock = false
        return
      }

      let postData = {}
      postData.notes = that.writeResult
      let re = window.confirm('确认提交？')
      if(re){
            submitInterviewRecords(id, postData).then(() => {
            Toast('提交成功')
            setTimeout(function(){
              //that.getInterviewRecordsDetailFromDingMessage(that.id)
              that.tijiaoSuccess = true
              that.tijiaoLock = false
            },2000)
          }).catch((error) => {
            that.tijiaoLock = false
            Toast(error)
          })
      }
    },

  },
  created() {
    console.log('result yemian')
    const that = this;
    that.tijiaoSuccess = false
    const page = decodeURIComponent(this.$route.query.page);
    let tempArr = page.split('&')
    // window.alert(tempArr[0])
    that.id = tempArr[0]
    console.log('id', tempArr[0])
    that.getInterviewRecordsDetailFromDingMessage(that.id);
  },
}
</script>

<style lang="less">
.no-data{
  height: 2rem;
  line-height: 2rem;
  font-size: .4rem;
  color: #666;
  text-align: center;
}
.white-wrap {
  background-color: #fff;
}

.info-item {
  font-size: .36rem;
  line-height: 0.9rem;
  margin-left: .3rem;
  margin-right: .3rem;
  border-bottom: 1px solid #eee;

  &.last {
    border-bottom: 0;
  }

  .field {
    float: left;
    color: #333;
  }

  .value {
    float: right;
    color: #666;
  }
}

.p-item {
  &.last {
    border-bottom: 0;
  }

  margin-left: .3rem;
  margin-right: .3rem;
  font-size: .26rem;
  color: #666;
  line-height: .4rem;
  padding-bottom: .3rem;
  border-bottom: 1px solid #eee;
}

.block-title {
  font-size: .4rem;
  line-height: .6rem;
  color: #333;
  padding-left: .3rem;
  margin-top: .3rem;
  padding-top: .3rem;
}

.thing {
  padding-bottom: .2rem;
}

.sub-title {
  font-size: .38rem;
  line-height: .6rem;
  color: #333;
  padding-top: .2rem;
  padding-left: .3rem;
  margin-top: .3rem;
  border-top: .05rem solid #eee
}

.person {
  padding-left: .3rem;
  padding-right: .3rem;
  border-bottom: 1px solid #eee;
  padding-bottom: .1rem;
  margin-bottom: .1rem;

  &.last {
    border-bottom: 0;
  }

  .name {
    font-size: .34rem;
    color: #333;

    .tag {
      &.wait {
        border: 1px solid #faa855;
        color: #fa8d1d;
      }

      display: inline-block;
      width: 1.06rem;
      height: .36rem;
      border: 1px solid #5199ff;
      margin-left: .15rem;
      line-height: .36rem;
      text-align: center;
      border-radius: .06rem;
      color: #1c7aff;
      font-size: .24rem;
      vertical-align: top;
      margin-top: .03rem;
    }
  }

  .date, .info {
    font-size: .30rem;
    color: #949494;
    line-height: .45rem;
  }
}

.text-area {
  width: 6.9rem;
  margin-left: .3rem;
  height: 3rem;
  box-sizing: border-box;
  padding: .2rem;
  font-size: .32rem;
  line-height: .4rem;
  outline: none;
  border: 1px solid #efefef;
  background-color: #f5f6f8;
  border-radius: 0.12rem;
  resize: none;
}

.sub-btn {
  width: 6.9rem;
  height: 1rem;
  background-color: #1677ff;
  margin-left: .3rem;
  color: #fff;
  line-height: 1rem;
  font-size: .37rem;
  text-align: center;
  margin-top: .3rem;
  margin-bottom: 1rem;
  border-radius: .12rem;
}

.success{
  text-align: center;
  padding-top:0.8rem;
  .tip{
    font-size: 0.4rem;
    color:#666;
    line-height: 0.9rem;
  }
}


</style>
